import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';
import Switches from '../../../../../components/fields/Switches/Switches';
import { addressTransform } from '../../../../../utils/utils';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import FileInput from '../../../../../components/fields/FileInput/FileInput';
import AddressInput from '../../../../../components/fields/Address/AddressInput';
import ApplicantDTO from '../../../../../dto/ApplicantDTO';

export default function SPBForm(props) {
  const {
    prefix = 'applicant_new.',
    control,
    formMeta,
    applicantType,
    procedure,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const [showOfficeName, setShowOfficeName] = useState(
    isEdit ? !!currentApplication?.applicant_new?.office_name || currentApplication?.applicant_new?.office_name === null : false,
  );
  const [showOfficeLegalAddress, setShowOfficeLegalAddress] = useState(
    isEdit ? !!currentApplication?.applicant_new?.office_address || currentApplication?.applicant_new?.office_address === null : false,
  );
  const [showOfficeLocationAddress, setShowOfficeLocationAddress] = useState(
    isEdit ? !!currentApplication?.applicant_new?.office_address || currentApplication?.applicant_new?.office_address === null : false,
  );
  const [showOfficePhone, setShowOfficePhone] = useState(
    isEdit ? !!currentApplication?.applicant_new?.office_phone || currentApplication?.applicant_new?.office_phone === null : false,
  );
  const [showOfficeEmail, setShowOfficeEmail] = useState(
    isEdit ? !!currentApplication?.applicant_new?.office_email || currentApplication?.applicant_new?.office_email === null : false,
  );
  const [showOfficeTermination, setShowOfficeTermination] = useState(false);

  const dto = new ApplicantDTO();
  const attributes = dto.getAttributesByName();

  useEffect(() => {
    setValue('applicant_new.office_name', !showOfficeName ? null : (isEdit ? getValues('applicant_new.office_name') || '' : ''));
  }, [showOfficeName]);

  useEffect(() => {
    setValue('applicant_new.office_address', !showOfficeLegalAddress ? null : (isEdit ? getValues('applicant_new.office_address') || '' : ''));
  }, [showOfficeLegalAddress]);

  useEffect(() => {
    setValue('applicant_new.office_address', !showOfficeLocationAddress ? null : (isEdit ? getValues('applicant_new.office_address') || '' : ''));
  }, [showOfficeLocationAddress]);

  useEffect(() => {
    setValue('applicant_new.office_phone', !showOfficePhone ? null : (isEdit ? getValues('applicant_new.office_phone') || '' : ''));
  }, [showOfficePhone]);

  useEffect(() => {
    setValue('applicant_new.office_email', !showOfficeEmail ? null : (isEdit ? getValues('applicant_new.office_email') || '' : ''));
  }, [showOfficeEmail]);

  useEffect(() => {
    if (!showOfficeTermination) {
      setValue('media.office_name_change_document', null);
    }
  }, [showOfficeTermination]);

  if (![PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) || applicantType !== USER_TYPE.LEGAL) {
    return null;
  }

  return (
    <>
      <div className="f3 mt-3">Изменились сведения о филиале (представительстве) в Санкт-Петербурге</div>

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowOfficeName(!showOfficeName),
              value: showOfficeName,
            }}
            label="Изменилось наименование филиала"
          />
        </Col>
      </Row>
      {showOfficeName && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.office_name}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new."
          />
        </Row>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowOfficeLegalAddress(!showOfficeLegalAddress),
              value: showOfficeLegalAddress,
            }}
            label="Изменился юридический адрес филиала"
          />
        </Col>
      </Row>
      {showOfficeLegalAddress && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.office_address}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new.sp."
          />
        </Row>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowOfficeLocationAddress(!showOfficeLocationAddress),
              value: showOfficeLocationAddress,
            }}
            label="Изменился адрес местонахождения"
          />
        </Col>
      </Row>
      {showOfficeLocationAddress && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={AddressInput}
            dtoObject={attributes.office_address}
            label="Новый адрес местонахождения"
            transform={addressTransform}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new."
          />
        </Row>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowOfficePhone(!showOfficePhone),
              value: showOfficePhone,
            }}
            label="Изменился телефонный номер"
          />
        </Col>
      </Row>
      {showOfficePhone && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.office_phone}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new."
          />
        </Row>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowOfficeEmail(!showOfficeEmail),
              value: showOfficeEmail,
            }}
            label="Изменилась электронная почта"
          />
        </Col>
      </Row>
      {showOfficeEmail && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.office_email}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new."
          />
        </Row>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowOfficeTermination(!showOfficeTermination),
              value: showOfficeTermination,
            }}
            label="Филиал прекратил деятельность"
          />
        </Col>
      </Row>
      {showOfficeTermination && (
        <>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.office_name}
              variant="material"
              namePrefix={`${prefix}terminate_`}
              labelPrefix="terminate."
              label="Наименование филиала"
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.office_name_change_document}
              variant="material"
              namePrefix="media."
            />
          </Row>
        </>
      )}

      <div className="hr-row mt-3" />
    </>
  );
}
